import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Subscription } from 'rxjs';
import { SiteManagementService } from '../../../../services/api/site-management.service';
import { TokenStorageService } from '../../../../services/token-storage/token-storage.service';

@Component({
  standalone: false,
  selector: 'app-layout-template',
  templateUrl: './layout-template.component.html',
  styleUrl: './layout-template.component.css',
  host: {'class': 'd-flex flex-column vh-100'} //Styles needed for layout
})
export class LayoutTemplateComponent implements OnInit, OnDestroy {
  showHeader: boolean = true;
  showFooter: boolean = true;
  isOracle: boolean = false;
  private profileSubscription: Subscription | null = null;
  private profileCheckStarted = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private siteManagementService: SiteManagementService,
    private tokenStorage: TokenStorageService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) { }

  ngOnInit(): void {
    const profileStr = sessionStorage.getItem('UserProfile');
    const profile = profileStr ? JSON.parse(profileStr) : null;
    this.isOracle = !!profile?.ofc;

    this.route.data.subscribe(data => {
      this.showHeader = data['showHeader'] !== false;
      // Login also uses this layout (showHeader: false). Do not call profile there.
      if (this.showHeader && !this.profileCheckStarted) {
        this.profileCheckStarted = true;
        void this.verifyUserProfile();
      }
    });
  }

  private async verifyUserProfile(): Promise<void> {
    try {
      const user = await this.oktaAuth.getUser();
      const email = user?.email;
      if (!email || typeof email !== 'string') {
        this.denyAccess();
        return;
      }

      this.profileSubscription = this.siteManagementService.getUserProfile(email).subscribe({
        next: (profile) => {
          if (!profile) {
            return;
          }
          sessionStorage.setItem('UserProfile', JSON.stringify(profile));
          if (profile.roleName) {
            this.tokenStorage.setRole(profile.roleName);
          }
          this.isOracle = !!profile.ofc;
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error fetching user profile from layout:', error);
          if (error?.status === 403) {
            this.denyAccess();
          }
        }
      });
    } catch (error) {
      console.error('Unable to read Okta user in layout', error);
    }
  }

  private denyAccess(): void {
    this.tokenStorage.clearSession();
    this.router.navigate(['/access-denied']);
  }

  ngOnDestroy(): void {
    this.profileSubscription?.unsubscribe();
  }
}
